import { Plane } from 'lucide-react';
import { DivisionPage } from '../components/DivisionPage';
import { CTASection } from '../components/CTASection';

export function AvionicsPage() {
  return (
    <DivisionPage
      accent="accent-avionics"
      icon={Plane}
      nameKey="avionics.name"
      badgeKey="avionics.badge"
      titleKey="avionics.heroTitle"
      leadKey="avionics.heroLead"
      pitchKey="avionics.pitch"
      specs={[
        { labelKey: 'avionics.specPayload', valueKey: 'avionics.specPayloadV' },
        { labelKey: 'avionics.specGrip', valueKey: 'avionics.specGripV' },
        { labelKey: 'avionics.specRole', valueKey: 'avionics.specRoleV' },
      ]}
      features={[
        { titleKey: 'avionics.s1t', descKey: 'avionics.s1d' },
        { titleKey: 'avionics.s2t', descKey: 'avionics.s2d' },
        { titleKey: 'avionics.s3t', descKey: 'avionics.s3d' },
        { titleKey: 'avionics.s4t', descKey: 'avionics.s4d' },
      ]}
      shots={[
        { src: '/mock/drone-drop.svg', captionKey: 'avionics.shot1' },
        { src: '/mock/drone-observer.svg', captionKey: 'avionics.shot2' },
        { src: '/mock/drone-swarm.svg', captionKey: 'avionics.shot3' },
      ]}
    >
      <CTASection />
    </DivisionPage>
  );
}
